<template>
  <div class="dimed" id="popupWrap">
    <div class="pop-up pop-keypad-wrap">
      <div class="pop-header">
        <span class="pop-title">선결제 금액 입력</span>
        <button
          class="btn-pop-close"
          id="btnClosePopup"
          @click="$.emit('close')"
        >
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-keypad-area">
        <input
          type="text"
          id="ipKeypad"
          name=""
          class="ip-keypad"
          :value="keypadData"
          placeholder="내용을 입력하세요"
        />
        <div class="bg-box-dark">
          <div class="keypad">
            <button @click="setKeypad(1)" type="button">
              1<span class="overlay"></span>
            </button>
            <button @click="setKeypad(2)" type="button">
              2<span class="overlay"></span>
            </button>
            <button @click="setKeypad(3)" type="button">
              3<span class="overlay"></span>
            </button>
            <button @click="setKeypad(4)" type="button">
              4<span class="overlay"></span>
            </button>
            <button @click="setKeypad(5)" type="button">
              5<span class="overlay"></span>
            </button>
            <button @click="setKeypad(6)" type="button">
              6<span class="overlay"></span>
            </button>
            <button @click="setKeypad(7)" type="button">
              7<span class="overlay"></span>
            </button>
            <button @click="setKeypad(8)" type="button">
              8<span class="overlay"></span>
            </button>
            <button @click="setKeypad(9)" type="button">
              9<span class="overlay"></span>
            </button>
            <button @click="setKeypad(0)" type="button" class="r2c1">
              0<span class="overlay"></span>
            </button>
            <button @click="setKeypad('00')" type="button">
              00<span class="overlay"></span>
            </button>
          </div>
          <div class="keypad-side">
            <button @click="setKeypad(10)" type="button" class="btn-c">
              C<span class="overlay"></span>
            </button>
            <button @click="setKeypad(-1)" type="button" class="btn-del">
              <span class="overlay"></span>
            </button>
            <button @click="setKeypad('E')" type="button" class="btn-enter">
              <span class="overlay"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="pop-btn-area pd40">
        <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
        <button
          type="button"
          class="btn-pop btn-half btn-cancel"
          @click="$.emit('close')"
        >
          취소<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-pop btn-half btn-submit"
          @click="complete"
        >
          입력완료<span class="overlay"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "keypad",
  props: {},
  data() {
    return {
      keypadData: "",
    };
  },
  computed: {},
  methods: {
    complete() {
      this.$.emit("complete", this.keypadData);
    },
    setKeypad(str) {
      if (str == "E") {
        this.complete();
      } else if (str < 0) {
        this.keypadData = this.keypadData.slice(0, -1);
      } else if (str == 10) {
        this.keypadData = "";
      } else {
        this.keypadData += String(str) + "";
      }
    },
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>